module.exports = __webpack_public_path__ + "static/media/volvo-go-drive.41dadba2.jpg";